import { contactRoutes, contactNavigationItems } from "./router";
/**
 * Contact Module
 */
export class ContactModule {
    constructor() {
        Object.defineProperty(this, "contracts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
    }
    register(contracts) {
        this.contracts = contracts;
        contracts.logger.debug("[ContactModule] Registered");
        return {
            id: "contact",
            name: "Contact Module",
            version: "1.0.0",
        };
    }
    getRoutes() {
        return contactRoutes;
    }
    getNavigationItems() {
        return contactNavigationItems;
    }
    getComponent() {
        return null;
    }
    unregister() {
        this.contracts?.logger.debug("[ContactModule] Unregistered");
        this.contracts = null;
    }
}
export default new ContactModule();
